import React from 'react';
import { CreateRequestEntry } from '@/features/request-gateway';

interface GatewayCreateRequestOverlayProps {
  isOpen: boolean;
  onClose: () => void;
  onSuccess?: () => void;
  activeRole?: string;
  roleLabel?: string;
}

/** Unified Create Request Hub — no shortened forms or modal stubs. */
export const GatewayCreateRequestOverlay: React.FC<GatewayCreateRequestOverlayProps> = ({
  isOpen,
  onClose,
  onSuccess,
  activeRole = 'STUDENT',
  roleLabel = 'Обучающийся',
}) => {
  return (
    <CreateRequestEntry
      isOpen={isOpen}
      onClose={onClose}
      onBack={onClose}
      onSuccess={onSuccess}
      activeRole={activeRole}
      roleLabel={roleLabel}
    />
  );
};
